// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconStyledForChips_icon__1xxwxIgcGY409MNz_PA-4h","avatar":"IconStyledForChips_avatar__1lGHvQmWrJZMWawbaJudw9"};